"use strict";

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _slicedToArray = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");
var _classCallCheck = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");
var _createClass = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var DefaultTransceiverController = /*#__PURE__*/function () {
  function DefaultTransceiverController(logger, browserBehavior) {
    _classCallCheck(this, DefaultTransceiverController);
    this.logger = logger;
    this.browserBehavior = browserBehavior;
    this._localCameraTransceiver = null;
    this._localAudioTransceiver = null;
    this.videoSubscriptions = [];
    this.defaultMediaStream = null;
    this.peer = null;
    this.streamIdToTransceiver = new Map();
  }
  _createClass(DefaultTransceiverController, [{
    key: "setEncodingParameters",
    value: function setEncodingParameters(encodingParamMap) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var sender, newEncodingParams, oldParam, _iterator, _step, existing, _iterator2, _step2, changed, key;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!this._localCameraTransceiver || this._localCameraTransceiver.direction !== 'sendrecv')) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              sender = this._localCameraTransceiver.sender;
              if (!(!encodingParamMap || encodingParamMap.size === 0)) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return");
            case 5:
              newEncodingParams = Array.from(encodingParamMap.values());
              oldParam = sender.getParameters();
              if (!(!oldParam.encodings || oldParam.encodings.length === 0)) {
                _context.next = 11;
                break;
              }
              oldParam.encodings = newEncodingParams;
              _context.next = 52;
              break;
            case 11:
              _iterator = _createForOfIteratorHelper(oldParam.encodings);
              _context.prev = 12;
              _iterator.s();
            case 14:
              if ((_step = _iterator.n()).done) {
                _context.next = 44;
                break;
              }
              existing = _step.value;
              _iterator2 = _createForOfIteratorHelper(newEncodingParams);
              _context.prev = 17;
              _iterator2.s();
            case 19:
              if ((_step2 = _iterator2.n()).done) {
                _context.next = 34;
                break;
              }
              changed = _step2.value;
              if (!((existing.rid || changed.rid) && existing.rid !== changed.rid)) {
                _context.next = 23;
                break;
              }
              return _context.abrupt("continue", 32);
            case 23:
              key = void 0;
              _context.t0 = _regeneratorRuntime().keys(changed);
            case 25:
              if ((_context.t1 = _context.t0()).done) {
                _context.next = 32;
                break;
              }
              key = _context.t1.value;
              if (!(key === 'rid' || key === 'codecPayloadType')) {
                _context.next = 29;
                break;
              }
              return _context.abrupt("continue", 25);
            case 29:
              /* istanbul ignore else */
              if (changed.hasOwnProperty(key)) {
                existing[key] = changed[key];
              }
              _context.next = 25;
              break;
            case 32:
              _context.next = 19;
              break;
            case 34:
              _context.next = 39;
              break;
            case 36:
              _context.prev = 36;
              _context.t2 = _context["catch"](17);
              _iterator2.e(_context.t2);
            case 39:
              _context.prev = 39;
              _iterator2.f();
              return _context.finish(39);
            case 42:
              _context.next = 14;
              break;
            case 44:
              _context.next = 49;
              break;
            case 46:
              _context.prev = 46;
              _context.t3 = _context["catch"](12);
              _iterator.e(_context.t3);
            case 49:
              _context.prev = 49;
              _iterator.f();
              return _context.finish(49);
            case 52:
              _context.next = 54;
              return sender.setParameters(oldParam);
            case 54:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[12, 46, 49, 52], [17, 36, 39, 42]]);
      }));
    }
  }, {
    key: "localAudioTransceiver",
    value: function localAudioTransceiver() {
      return this._localAudioTransceiver;
    }
  }, {
    key: "localVideoTransceiver",
    value: function localVideoTransceiver() {
      return this._localCameraTransceiver;
    }
  }, {
    key: "setVideoSendingBitrateKbps",
    value: function setVideoSendingBitrateKbps(bitrateKbps) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var sender;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(!this._localCameraTransceiver || this._localCameraTransceiver.direction !== 'sendrecv')) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              sender = this._localCameraTransceiver.sender;
              _context2.next = 5;
              return DefaultTransceiverController.setVideoSendingBitrateKbpsForSender(sender, bitrateKbps, this.logger);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "setPeer",
    value: function setPeer(peer) {
      this.peer = peer;
    }
  }, {
    key: "reset",
    value: function reset() {
      this._localCameraTransceiver = null;
      this._localAudioTransceiver = null;
      this.videoSubscriptions = [];
      this.defaultMediaStream = null;
      this.peer = null;
    }
  }, {
    key: "useTransceivers",
    value: function useTransceivers() {
      if (!this.peer || !this.browserBehavior.requiresUnifiedPlan()) {
        return false;
      }
      return typeof this.peer.getTransceivers !== 'undefined';
    }
  }, {
    key: "hasVideoInput",
    value: function hasVideoInput() {
      if (!this._localCameraTransceiver || this._localCameraTransceiver.direction !== 'sendrecv') return false;
      return true;
    }
  }, {
    key: "trackIsVideoInput",
    value: function trackIsVideoInput(track) {
      if (!this._localCameraTransceiver) {
        return false;
      }
      return track === this._localCameraTransceiver.sender.track || track === this._localCameraTransceiver.receiver.track;
    }
  }, {
    key: "setupLocalTransceivers",
    value: function setupLocalTransceivers() {
      if (!this.useTransceivers()) {
        return;
      }
      if (!this.defaultMediaStream && typeof MediaStream !== 'undefined') {
        this.defaultMediaStream = new MediaStream();
      }
      if (!this._localAudioTransceiver) {
        this._localAudioTransceiver = this.peer.addTransceiver('audio', {
          direction: 'inactive',
          streams: [this.defaultMediaStream]
        });
      }
      if (!this._localCameraTransceiver) {
        this._localCameraTransceiver = this.peer.addTransceiver('video', {
          direction: 'inactive',
          streams: [this.defaultMediaStream]
        });
      }
    }
  }, {
    key: "replaceAudioTrack",
    value: function replaceAudioTrack(track) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(!this._localAudioTransceiver || this._localAudioTransceiver.direction !== 'sendrecv')) {
                _context3.next = 3;
                break;
              }
              this.logger.info("audio transceiver direction is not set up or not activated");
              return _context3.abrupt("return", false);
            case 3:
              _context3.next = 5;
              return this._localAudioTransceiver.sender.replaceTrack(track);
            case 5:
              return _context3.abrupt("return", true);
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "setAudioInput",
    value: function setAudioInput(track) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.setTransceiverInput(this._localAudioTransceiver, track);
            case 2:
              return _context4.abrupt("return");
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "setVideoInput",
    value: function setVideoInput(track) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return this.setTransceiverInput(this._localCameraTransceiver, track);
            case 2:
              return _context5.abrupt("return");
            case 3:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "updateVideoTransceivers",
    value: function updateVideoTransceivers(videoStreamIndex, videosToReceive) {
      var _this = this;
      if (!this.useTransceivers()) {
        return videosToReceive.array();
      }
      // See https://blog.mozilla.org/webrtc/rtcrtptransceiver-explored/ for details on transceivers
      var transceivers = this.peer.getTransceivers();
      // Subscription index 0 is reserved for transmitting camera.
      // We mark inactive slots with 0 in the subscription array.
      this.videoSubscriptions = [0];
      videosToReceive = videosToReceive.clone();
      this.updateTransceivers(transceivers, videoStreamIndex, videosToReceive);
      this.logger.debug(function () {
        return _this.debugDumpTransceivers();
      });
      return this.videoSubscriptions;
    }
  }, {
    key: "updateTransceivers",
    value: function updateTransceivers(transceivers, videoStreamIndex, videosToReceive) {
      var videosRemaining = videosToReceive.array();
      if (transceivers.length !== 0 && !transceivers[0].stop) {
        // This function and its usage can be removed once we raise Chrome browser requirements
        // to M88 (when `RTCRtpTransceiver.stop` was added)
        this.logger.info('Updating transceivers without `stop` function');
        this.updateTransceiverWithoutStop(transceivers, videoStreamIndex, videosRemaining);
      } else if (transceivers.length !== 0) {
        this.updateTransceiverWithStop(transceivers, videoStreamIndex, videosRemaining);
      }
      // Add transceivers for the remaining subscriptions
      var _iterator3 = _createForOfIteratorHelper(videosRemaining),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var index = _step3.value;
          // @ts-ignore
          var transceiver = this.peer.addTransceiver('video', {
            direction: 'recvonly',
            streams: [new MediaStream()]
          });
          this.streamIdToTransceiver.set(index, transceiver);
          this.videoSubscriptions.push(index);
          this.logger.info("adding transceiver mid: ".concat(transceiver.mid, " subscription: ").concat(index, " direction: recvonly"));
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }, {
    key: "updateTransceiverWithStop",
    value: function updateTransceiverWithStop(transceivers, videoStreamIndex, videosRemaining) {
      // Begin counting out index in the the subscription array at 1 since the camera.
      // Always occupies position 0 (whether active or not).
      var n = 1;
      // Reset since otherwise there will be stale indexes corresponding to
      // stopped transceivers.
      this.videoSubscriptions = [0];
      var _iterator4 = _createForOfIteratorHelper(transceivers),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var transceiver = _step4.value;
          if (transceiver === this._localCameraTransceiver || !this.transceiverIsVideo(transceiver) || !transceiver.mid) {
            continue;
          }
          var reusingTranceiver = false;
          // See if we want this existing transceiver for a simulcast stream switch
          //
          // By convention with the service backend, msid is equal to the media section mid, prefixed with the string "v_";
          // we use this to get the stream ID for the track
          var streamId = videoStreamIndex.streamIdForTrack('v_' + transceiver.mid);
          if (transceiver.direction !== 'inactive' && streamId !== undefined) {
            var _iterator5 = _createForOfIteratorHelper(videosRemaining.entries()),
              _step5;
            try {
              for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                var _step5$value = _slicedToArray(_step5.value, 2),
                  index = _step5$value[0],
                  recvStreamId = _step5$value[1];
                // `streamId` may still be the same as `recvStreamId`
                if (videoStreamIndex.StreamIdsInSameGroup(streamId, recvStreamId)) {
                  transceiver.direction = 'recvonly';
                  this.videoSubscriptions[n] = recvStreamId;
                  reusingTranceiver = true;
                  this.streamIdToTransceiver.delete(streamId);
                  this.streamIdToTransceiver.set(recvStreamId, transceiver);
                  videosRemaining.splice(index, 1);
                  break;
                }
              }
            } catch (err) {
              _iterator5.e(err);
            } finally {
              _iterator5.f();
            }
          }
          if (!reusingTranceiver) {
            this.videoSubscriptions[n] = 0;
            this.logger.info("Stopping MID: ".concat(transceiver.mid, ", direction: ").concat(transceiver.direction, ", current direction: ").concat(transceiver.currentDirection));
            // Clean up transceiver and mappings for streams that have been unsubscribed from.  Note we do not try to reuse
            // old inactive transceivers for new streams as Firefox will reuse the last frame from
            // that transceiver, and additionally we simply don't want to risk wiring up a transceiver
            // to the incorrect video stream for no real benefit besides possible a smaller SDP size.
            transceiver.stop(); // Note (as of Firefox 94): Firefox will keep these around forever
            var _iterator6 = _createForOfIteratorHelper(this.streamIdToTransceiver.entries()),
              _step6;
            try {
              for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                var _step6$value = _slicedToArray(_step6.value, 2),
                  _streamId = _step6$value[0],
                  previousTransceiver = _step6$value[1];
                if (transceiver.mid === previousTransceiver.mid) {
                  this.streamIdToTransceiver.delete(_streamId);
                }
              }
            } catch (err) {
              _iterator6.e(err);
            } finally {
              _iterator6.f();
            }
          }
          n += 1;
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    } // This function operates similarily to `updateTransceiverWithStop` with the following changes to account
    // for the fact RTCRtpTransceiver.stop is not available on all supported browsers:
    //  * We attempt to reuse inactive transceivers because libwebrtc will not remove them otherwise and
    //    the SDP will grow endlessly.
    //  * We mark unsubscribed transceivers as 'inactive' so that they can be reused. This requires using a
    //    second for loop.
  }, {
    key: "updateTransceiverWithoutStop",
    value: function updateTransceiverWithoutStop(transceivers, videoStreamIndex, videosRemaining) {
      var n = 1;
      var _iterator7 = _createForOfIteratorHelper(transceivers),
        _step7;
      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var transceiver = _step7.value;
          if (transceiver === this._localCameraTransceiver || !this.transceiverIsVideo(transceiver)) {
            continue;
          }
          this.videoSubscriptions[n] = 0;
          if (transceiver.direction !== 'inactive') {
            var streamId = videoStreamIndex.streamIdForTrack('v_' + transceiver.mid);
            if (streamId !== undefined) {
              var _iterator9 = _createForOfIteratorHelper(videosRemaining.entries()),
                _step9;
              try {
                for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                  var _step9$value = _slicedToArray(_step9.value, 2),
                    index = _step9$value[0],
                    recvStreamId = _step9$value[1];
                  if (videoStreamIndex.StreamIdsInSameGroup(streamId, recvStreamId)) {
                    transceiver.direction = 'recvonly';
                    this.videoSubscriptions[n] = recvStreamId;
                    this.streamIdToTransceiver.delete(streamId);
                    this.streamIdToTransceiver.set(recvStreamId, transceiver);
                    videosRemaining.splice(index, 1);
                    break;
                  }
                }
              } catch (err) {
                _iterator9.e(err);
              } finally {
                _iterator9.f();
              }
            }
          }
          n += 1;
        }
        // Next fill in open slots and remove unused
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
      n = 1;
      var _iterator8 = _createForOfIteratorHelper(transceivers),
        _step8;
      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var _transceiver = _step8.value;
          if (_transceiver === this._localCameraTransceiver || !this.transceiverIsVideo(_transceiver)) {
            continue;
          }
          if (_transceiver.direction === 'inactive' && videosRemaining.length > 0) {
            // Fill available slot
            _transceiver.direction = 'recvonly';
            var _streamId2 = videosRemaining.shift();
            this.videoSubscriptions[n] = _streamId2;
            this.streamIdToTransceiver.set(_streamId2, _transceiver);
          } else {
            // Remove if no longer subscribed
            if (this.videoSubscriptions[n] === 0) {
              _transceiver.direction = 'inactive';
              var _iterator10 = _createForOfIteratorHelper(this.streamIdToTransceiver.entries()),
                _step10;
              try {
                for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
                  var _step10$value = _slicedToArray(_step10.value, 2),
                    _streamId3 = _step10$value[0],
                    previousTransceiver = _step10$value[1];
                  if (_transceiver === previousTransceiver) {
                    this.streamIdToTransceiver.delete(_streamId3);
                  }
                }
              } catch (err) {
                _iterator10.e(err);
              } finally {
                _iterator10.f();
              }
            }
          }
          n += 1;
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
    }
  }, {
    key: "getMidForStreamId",
    value: function getMidForStreamId(streamId) {
      var _a;
      return (_a = this.streamIdToTransceiver.get(streamId)) === null || _a === void 0 ? void 0 : _a.mid;
    }
  }, {
    key: "setStreamIdForMid",
    value: function setStreamIdForMid(mid, newStreamId) {
      var _iterator11 = _createForOfIteratorHelper(this.streamIdToTransceiver.entries()),
        _step11;
      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var _step11$value = _slicedToArray(_step11.value, 2),
            streamId = _step11$value[0],
            transceiver = _step11$value[1];
          if (transceiver.mid === mid) {
            this.streamIdToTransceiver.delete(streamId);
            this.streamIdToTransceiver.set(newStreamId, transceiver);
            return;
          }
        }
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }
    }
  }, {
    key: "transceiverIsVideo",
    value: function transceiverIsVideo(transceiver) {
      return transceiver.receiver && transceiver.receiver.track && transceiver.receiver.track.kind === 'video' || transceiver.sender && transceiver.sender.track && transceiver.sender.track.kind === 'video';
    }
  }, {
    key: "debugDumpTransceivers",
    value: function debugDumpTransceivers() {
      var msg = '';
      var n = 0;
      var _iterator12 = _createForOfIteratorHelper(this.peer.getTransceivers()),
        _step12;
      try {
        for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
          var transceiver = _step12.value;
          if (!this.transceiverIsVideo(transceiver)) {
            continue;
          }
          msg += "transceiver index=".concat(n, " mid=").concat(transceiver.mid, " subscription=").concat(this.videoSubscriptions[n], " direction=").concat(transceiver.direction, "\n");
          n += 1;
        }
      } catch (err) {
        _iterator12.e(err);
      } finally {
        _iterator12.f();
      }
      return msg;
    }
  }, {
    key: "setTransceiverInput",
    value: function setTransceiverInput(transceiver, track) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (transceiver) {
                _context6.next = 2;
                break;
              }
              return _context6.abrupt("return");
            case 2:
              if (track) {
                transceiver.direction = 'sendrecv';
              } else {
                transceiver.direction = 'inactive';
              }
              _context6.next = 5;
              return transceiver.sender.replaceTrack(track);
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
    }
  }], [{
    key: "setVideoSendingBitrateKbpsForSender",
    value: function setVideoSendingBitrateKbpsForSender(sender, bitrateKbps, _logger) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var param, _iterator13, _step13, encodeParam;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (!(!sender || bitrateKbps <= 0)) {
                _context7.next = 2;
                break;
              }
              return _context7.abrupt("return");
            case 2:
              param = sender.getParameters();
              if (!param.encodings) {
                param.encodings = [{}];
              }
              _iterator13 = _createForOfIteratorHelper(param.encodings);
              try {
                for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
                  encodeParam = _step13.value;
                  encodeParam.maxBitrate = bitrateKbps * 1000;
                }
              } catch (err) {
                _iterator13.e(err);
              } finally {
                _iterator13.f();
              }
              _context7.next = 8;
              return sender.setParameters(param);
            case 8:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
    }
  }, {
    key: "replaceAudioTrackForSender",
    value: function replaceAudioTrackForSender(sender, track) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (sender) {
                _context8.next = 2;
                break;
              }
              return _context8.abrupt("return", false);
            case 2:
              _context8.next = 4;
              return sender.replaceTrack(track);
            case 4:
              return _context8.abrupt("return", true);
            case 5:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }));
    }
  }]);
  return DefaultTransceiverController;
}();
exports.default = DefaultTransceiverController;